import { BaseService } from './base';
import { ApiRequest } from '../lib/request';
import type { ApiResponse } from '../lib/response';

import { FrontDesk, FrontDeskReservationCustomerCheckin } from '../models/frontDesk';
import { ReservationCustomer } from '../models/reservationCustomer';

export class FrontDeskService extends BaseService<FrontDesk> {
  override model = FrontDesk;
  override modelName = 'frontDesk';
  override modelLabel = 'Front Desk';

  async reservationCustomerCheckinBuySingle(
    reservationCustomer: { idReservationCustomer: number },
    price: number,
  ): Promise<ApiResponse<FrontDeskReservationCustomerCheckin>> {
    const request = new ApiRequest({
      method: 'GET',
      url: `${this.modelBaseUrl}/reservationCustomerCheckinBuySingle`,
      query: {
        reservationCustomer: reservationCustomer.idReservationCustomer.toString(),
        price: price.toString(),
      },
    });

    return await this.requestItem(request, FrontDeskReservationCustomerCheckin);
  }

  async reservationCustomerCheckinBuyPass(
    reservationCustomer: { idReservationCustomer: number },
    pass: { idPass: number },
    price: number,
  ): Promise<ApiResponse<FrontDeskReservationCustomerCheckin>> {
    const request = new ApiRequest({
      method: 'GET',
      url: `${this.modelBaseUrl}/reservationCustomerCheckinBuyPass`,
      query: {
        reservationCustomer: reservationCustomer.idReservationCustomer.toString(),
        pass: pass.idPass.toString(),
        price: price.toString(),
      },
    });

    return await this.requestItem(request, FrontDeskReservationCustomerCheckin);
  }

  async reservationAddCustomer(
    reservation: { idReservation: number; date: number },
    customer: { idCustomer: number },
  ): Promise<ApiResponse<ReservationCustomer>> {
    const request = new ApiRequest({
      method: 'GET',
      url: `${this.modelBaseUrl}/reservationAddCustomer`,
      query: {
        reservation: reservation.idReservation.toString(),
        date: reservation.date.toString(),
        customer: customer.idCustomer.toString(),
      },
    });

    return await this.requestItem(request, ReservationCustomer);
  }
}
